const setKnowledgeCenterData = (postsObj) => {
    return {
        type: "SET_KNOWLEDGE_DATA",
        payload: postsObj
    }
}

const setKnowledgeCenterDataTrack = () => {
    return {
        type: "SET_KNOWLEDGE_DATATRACK"
    }
}


export default {
    setKnowledgeCenterData,
    setKnowledgeCenterDataTrack
}